import { Component, OnInit, Input, ViewChild } from '@angular/core';
import {DialogRef} from '@progress/kendo-angular-dialog';
import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { FormService } from '../../../fw/services/form.service';
import { ValidationMessageComponent } from '../../shared/validation-message.component';
import { SharedValidators } from '../../shared/shared-validators';
import { Observable } from 'rxjs/Rx';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {SharedService} from "../../shared/shared.service";
import {SettingsCashregService} from "./settings-cashreg.service";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {AsyncValidatorWrapper} from "../../../fw/helpers/async-validator-wrapper";
import {DtoTreatment} from "./models/DtoTreatment";
import {DtoTreatmentBaseItems} from "./models/DtoTreatmentBaseItems";

@Component({
    selector: 'treatment',
    template: require('./treatment.component.html'),
    styles: [require('./treatment.component.css')]
})
@AutoUnsubscribe()

export class TreatmentComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() id: number;
    @Input() copyFromId: number;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    @ViewChild('gridPriceMutation', {static: false}) gridPriceMutation: DynamicGridComponent;
    isCalculatingPrice: boolean;
    form: FormGroup;
    dtoObject: DtoTreatment;
    baseItems: DtoTreatmentBaseItems;
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];
    treatmentTypeItems: Array<{ text: string, value: string }> = [
        { text: '', value: '' },
        { text: 'Dame', value: 'Dame' },
        { text: 'Heer', value: 'Heer' },
        { text: 'Jeugd', value: 'Jeugd' }
    ];
    priceMutationColumnDefinition: ColumnDefinition[] = [
        {
            key: 'mutationDate',
            label: 'Ingangsdatum',
            type: 'date',
            width: '150px',
            format: '{0:dd-MM-yyyy}'
        },
        {
            key: 'btwDescription',
            label: 'BTW %',
            type: 'string',
            width: '*'
        },
        {
            key: 'retailPriceEx',
            label: 'Verkoopprijs excl.',
            type: 'number',
            width: '*',
            format: '{0:c}'
        },
        {
            key: 'retailPrice',
            label: 'Verkoopprijs incl.',
            type: 'number',
            width: '*',
            format: '{0:c}'
        }
    ];

    constructor(private fb: FormBuilder,
                private fs: FormService,
                private ds: SettingsCashregService,
                private ss: SharedService) {
    }

    ngOnInit() {
        this.form = this.fb.group({
            description: ['', [SharedValidators.customRequired]],
            index: [null,[SharedValidators.customRequired]],
            isActive: null,
            departmentId: [null, [SharedValidators.customRequired]],
            treatmentSalesgroupId: null,
            treatmentSubSalesgroupId: null,
            cashregGroupId: null,
            cashregSubGroupId: null,
            btwGroupId: [null, [SharedValidators.customRequired]],
            minuteRetailPrice: [{value: null, disabled: true}],
            treatmentType: null,
            retailPrice: null,
            retailPriceEx: null,
            customerAdvice: null,
            variablePrice: null,
            treatmentTime: null,
            grootboekNumber: null,
            employeeAdvice: null,
            treatmentKindId: null
        });

        this.form.valueChanges.subscribe(() =>
            {if (this.validationMessage) this.validationMessage.getFormValidationErrors();}
        );
        this.form.get('retailPrice').valueChanges.subscribe(newVal => {
            if (this.baseItems && !this.isCalculatingPrice && this.form.get('btwGroupId').value) {
                this.isCalculatingPrice = true;
                let btw = this.baseItems.btwGroups.find(x => x.id == this.form.get('btwGroupId').value);
                this.form.patchValue({ ['retailPriceEx']: this.ss.round(((newVal / (100 + btw.percentage)) * 100), 2) });
                if (newVal > 0 && this.form.value.treatmentTime > 0) {
                    this.form.patchValue({ ['minuteRetailPrice']: (newVal / this.form.value.treatmentTime) });
                } else {
                    this.form.patchValue({ ['minuteRetailPrice']: (0) });
                }
                this.isCalculatingPrice = false;
            }
        });
        this.form.get('treatmentTime').valueChanges.subscribe(newVal => {
            if (this.baseItems && !this.isCalculatingPrice) {
                this.isCalculatingPrice = true;
                if (newVal > 0 && this.form.value.retailPrice > 0) {
                    this.form.patchValue({ ['minuteRetailPrice']: (this.form.value.retailPrice / newVal) });
                } else {
                    this.form.patchValue({ ['minuteRetailPrice']: (0) });
                }
                this.isCalculatingPrice = false;
            }
        });
        this.form.get('btwGroupId').valueChanges.subscribe(newVal => {
            if (this.baseItems && !this.isCalculatingPrice && this.form.get('btwGroupId').value) {
                this.isCalculatingPrice = true;
                let btw = this.baseItems.btwGroups.find(x => x.id == newVal);
                this.form.patchValue({ ['retailPriceEx']: this.ss.round(((this.form.value.retailPrice / (100 + btw.percentage)) * 100), 2) });
                this.isCalculatingPrice = false;
            }
        });

        if (this.id > 0) {
            this.ds.getTreatmentById(this.id)
                .subscribe(response => {
                    this.dtoObject = response;
                    this.getBaseItems();
                    this.isCalculatingPrice = true;
                    this.fs.patchDtoToForm(this.dtoObject, this.form);
                    this.gridPriceMutation.showData(this.dtoObject.treatmentPriceMutations);
                    this.isCalculatingPrice = false;
                });
        }
        else {
            this.ds.getTreatmentNextIndex()
                .subscribe(res => {
                    this.dtoObject = {
                        id: 0,
                        index: res,
                        isActive: true,
                        retailPrice: 0,
                        retailPriceEx: 0,
                        variablePrice: true,
                        treatmentPriceMutations: [],
                        articleCombinations: [],
                        minuteRetailPrice: 0,
                        treatmentCombinations: [],
                        treatmentTime: 0,
                        treatmentKindId: 1
                    };
                    this.getBaseItems();

                    if (this.copyFromId > 0) {
                        this.ds.getTreatmentById(this.copyFromId)
                            .subscribe(response => {
                                this.dtoObject.treatmentTime = response.treatmentTime;
                                this.dtoObject.minuteRetailPrice = response.minuteRetailPrice;
                                this.dtoObject.btwGroupId = response.btwGroupId;
                                this.dtoObject.cashregGroupId = response.cashregGroupId;
                                this.dtoObject.cashregSubGroupId = response.cashregSubGroupId;
                                this.dtoObject.customerAdvice = response.customerAdvice;
                                this.dtoObject.departmentId = response.departmentId;
                                this.dtoObject.description = response.description;
                                this.dtoObject.isActive = response.isActive;
                                this.dtoObject.grootboekNumber = response.grootboekNumber;
                                this.dtoObject.retailPriceEx = response.retailPriceEx;
                                this.dtoObject.retailPrice = response.retailPrice;
                                this.dtoObject.treatmentSalesgroupId = response.treatmentSalesgroupId;
                                this.dtoObject.treatmentSubSalesgroupId = response.treatmentSubSalesgroupId;
                                this.dtoObject.treatmentType = response.treatmentType;
                                this.dtoObject.variablePrice = response.variablePrice;
                                this.fs.patchDtoToForm(this.dtoObject, this.form);
                            });
                    }
                    else {
                        this.fs.patchDtoToForm(this.dtoObject, this.form);
                    }
                });
        }
    }

    getBaseItems() {
        this.ds.getTreatmentBaseItems(false).subscribe(response => {
            this.baseItems = response;
            if (this.dtoObject && this.dtoObject.id == 0) {
                if (this.baseItems.departments.length == 1) {
                    this.dtoObject.departmentId = this.baseItems.departments[0].id;
                }
            }
        });
    }

    getSubSalesgroups() {
        if (this.baseItems && this.form.get('treatmentSalesgroupId').value) {
            return this.baseItems.salesgroups.find(x => x.id == this.form.get('treatmentSalesgroupId').value).treatmentSubSalesgroups;
        }
        return null;
    }

    getActiveBtwGroups() {
        if (this.baseItems) {
            return this.baseItems.btwGroups.filter(x => x.isActive);
        }
        return null;
    }

    getCashregSubGroups() {
        if (this.baseItems && this.form.get('cashregGroupId').value) {
            return this.baseItems.cashregGroups.find(x => x.id == this.form.get('cashregGroupId').value).cashregSubGroups;
        }
        return null;
    }

    checkForPriceChange() {
        let hasPriceChange: boolean = false;
        if (this.dtoObject.treatmentPriceMutations.length > 0) {
            let lastPrice = this.dtoObject.treatmentPriceMutations[0];
            hasPriceChange = ((lastPrice.btwGroupId != this.form.get('btwGroupId').value)
                || (lastPrice.retailPrice != this.form.get('retailPrice').value)
                || (lastPrice.retailPriceEx != this.form.get('retailPriceEx').value));
        }

        if (this.dtoObject.treatmentPriceMutations.length == 0 || hasPriceChange) {
            this.dtoObject.treatmentPriceMutations.push({
                id: 0,
                retailPriceEx: this.form.get('retailPriceEx').value,
                retailPrice: this.form.get('retailPrice').value,
                btwGroupId: this.form.get('btwGroupId').value,
                mutationDate: new Date(Date.now())
            });
        }
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid) {
            this.checkForPriceChange();
            this.form.controls['minuteRetailPrice'].enable();
            let result = this.fs.patchFormToDto(this.dtoObject, this.form);
            this.form.controls['minuteRetailPrice'].disable();
            this.ds.saveTreatment(result)
                .subscribe(response => {
                    if (!response.hasError) {
                        this.closeWindow(true);
                    }
                    else {
                        this.ss.message(response.errorMessage);
                    }
                });
        }
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-cashreg/treatment.component.ts